import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIcon } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DataGuardCheckError } from '@iot-platform/models/data-guard';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'iot-platform-feature-data-guard-check-error',
  imports: [FlexLayoutModule, TranslatePipe, MatIcon, MatTooltipModule],
  templateUrl: './check-error.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './check-error.component.scss'
})
export class CheckErrorComponent {
  checkError = input<DataGuardCheckError>();
}
